export default {
  // === SITE ===
  "site_name": "Croatia Times",
  "site_subtitle": "Croatia Today",

  // === NAVIGATION ===
  "home": "Home",
  "news": "News",
  "politics": "Politics",
  "business": "Business",
  "technology": "Technology",
  "sports": "Sports",
  "culture": "Culture",
  "lifestyle": "Lifestyle",
  "world": "World",
  "local": "Local",
  "entertainment": "Entertainment",
  "science": "Science",
  "health": "Health",
  "travel": "Travel",
  "economy": "Economy",
  "more": "More",

  // === AUTH ===
  "login": "Sign In",
  "register": "Register",
  "logout": "Sign Out",
  "profile": "Profile",
  "admin": "Admin",
  "password": "Password",
  "name": "Name",
  "email": "Email",
  "confirm_password": "Confirm Password",
  "already_have_account": "Already have an account?",
  "dont_have_account": "Don't have an account?",
  "or_continue_with": "Or continue with",
  "forgot_password": "Forgot password?",
  "myProfile": "My Profile",
  "adminPanel": "Admin Panel",
  "signOut": "Sign Out",
  "signIn": "Sign In",
  "noAccount": "Don't have an account?",
  "alreadyHaveAccount": "Already have an account?",
  "orContinueWith": "Or continue with",
  "two_factor_auth": "Two-Factor Authentication",
  "six_digit_code": "6-digit code",
  "code": "Code",
  "verification_code_sent": "Verification code sent to your email!",
  "new_verification_sent": "A new verification code has been sent to your email.",
  "invalid_code": "Invalid code. Try again.",
  "profile_verified": "Profile verified!",
  "facebook_login_unavailable": "Facebook login unavailable",
  "must_be_logged_in_purchase": "You must be logged in to purchase an article",

  // === COMMON UI ===
  "search": "Search...",
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "edit": "Edit",
  "create": "Create",
  "close": "Close",
  "back": "Back",
  "next": "Next",
  "previous": "Previous",
  "results": "Results",
  "no_results": "No results found",
  "submit": "Submit",
  "confirm": "Confirm",
  "actions": "Actions",
  "status": "Status",
  "active": "Active",
  "inactive": "Inactive",
  "pending": "Pending",
  "approved": "Approved",
  "rejected": "Rejected",
  "draft": "Draft",
  "published": "Published",
  "archived": "Archived",
  "all": "All",
  "filter": "Filter",
  "sort": "Sort",
  "export": "Export",
  "import": "Import",
  "download": "Download",
  "upload": "Upload",
  "refresh": "Refresh",
  "reset": "Reset",
  "apply": "Apply",
  "clear": "Clear",
  "select": "Select",
  "view": "View",
  "details": "Details",
  "description": "Description",
  "title": "Title",
  "date": "Date",
  "type": "Type",
  "category": "Category",
  "categories": "Categories",
  "tags": "Tags",
  "recent": "Recent",
  "popular": "Popular",
  "featured": "Featured",
  "new": "New",
  "update": "Update",
  "remove": "Remove",
  "add": "Add",
  "yes": "Yes",
  "no": "No",
  "on": "On",
  "off": "Off",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "online": "Online",
  "offline": "Offline",
  "total": "Total",
  "count": "Count",
  "percentage": "Percentage",
  "settings": "Settings",
  "options": "Options",
  "configure": "Configure",
  "manage": "Manage",
  "preview": "Preview",
  "publish": "Publish",
  "unpublish": "Unpublish",
  "approve": "Approve",
  "reject": "Reject",
  "dismiss": "Dismiss",
  "pause": "Pause",
  "resume": "Resume",
  "start": "Start",
  "stop": "Stop",
  "copy": "Copy",
  "paste": "Paste",
  "duplicate": "Duplicate",
  "move": "Move",
  "archive": "Archive",
  "restore": "Restore",
  "try_again": "Try Again",
  "email_address": "Email address",
  "phone": "Phone",
  "address": "Address",
  "city": "City",
  "country": "Country",
  "region": "Region",
  "search_placeholder": "Search...",
  "no_data": "No data available",
  "no_items": "No items found",
  "confirm_delete": "Are you sure you want to delete?",
  "saved_successfully": "Saved successfully",
  "deleted_successfully": "Deleted successfully",
  "updated_successfully": "Updated successfully",
  "error_saving": "Error saving",
  "error_deleting": "Error deleting",
  "error_loading": "Error loading",
  "error_uploading": "Error uploading",
  "select_all": "Select All",
  "deselect_all": "Deselect All",
  "items_selected": "items selected",
  "showing": "Showing",
  "of": "of",
  "per_page": "per page",
  "page": "Page",
  "first": "First",
  "last": "Last",
  "today": "Today",
  "yesterday": "Yesterday",
  "this_week": "This Week",
  "this_month": "This Month",
  "this_year": "This Year",
  "custom_range": "Custom Range",
  "from": "From",
  "to": "To",
  "hours": "hours",
  "minutes": "minutes",
  "seconds": "seconds",
  "days": "days",
  "ago": "ago",
  "just_now": "Just now",

  // === HEADER ===
  "header_live": "LIVE",
  "header_auto_schedule_active": "Auto-schedule active",
  "header_humidity": "Humidity",
  "header_wind": "Wind",
  "header_forecast": "Forecast",

  // === NEWSLETTER ===
  "newsletter": "Newsletter",
  "newsletter_desc": "Subscribe for the latest news",
  "subscribe": "Subscribe",
  "email_placeholder": "Your email address",
  "newsletter_subscribers": "Newsletter subscribers",
  "newsletter_only_subscribers": "Only subscribers",

  // === FOOTER ===
  "footer_description": "Croatia Times is your trusted source for breaking news, in-depth analysis, and engaging stories from Croatia and beyond.",
  "footer_categories": "Categories",
  "footer_quick_links": "Quick Links",
  "footer_stay_informed": "Stay Informed",
  "footer_newsletter_text": "Subscribe to our newsletter",
  "footer_email_placeholder": "Your email address",
  "footer_subscribe": "Subscribe",
  "footer_copyright": "2026 Liber Nostra d.o.o. All rights reserved.",
  "footer_ai_notice": "Some content created with AI assistance - report issues",
  "footer_here": "here",
  "footer_developed_by": "Developed and maintained with love by",
  "footer_hosted_by": "Hosted by",
  "footer_cat_news": "News",
  "footer_cat_politics": "Politics",
  "footer_cat_sports": "Sports",
  "footer_cat_business": "Business",
  "footer_cat_technology": "Technology",
  "footer_cat_culture": "Culture",
  "footer_cat_health": "Health",
  "footer_link_about": "About Us",
  "footer_link_contact": "Contact",
  "footer_link_privacy": "Privacy Policy",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Imprint",
  "footer_link_advertise": "Advertise",
  "footer_link_submit_news": "Submit News",
  "footer_ai": "This portal uses AI assistance to enhance user experience",
  "all_rights": "All rights reserved",

  // === THEME ===
  "dark_mode": "Dark Mode",
  "light_mode": "Light Mode",
  "language": "Language",

  // === SUBSCRIPTION & PAYMENTS ===
  "subscription": "Subscription",
  "free_plan": "Free",
  "choose_plan": "Choose Your Plan",
  "per_month": "/mo",
  "one_time": "one-time",
  "most_popular": "Most Popular",
  "current_plan": "Current Plan",
  "upgrade": "Upgrade",
  "payment_success": "Payment Successful!",
  "payment_error": "Payment Error",
  "premium": "Premium",
  "basic": "Basic",
  "lifetime": "Lifetime",
  "free": "Free",
  "promo_success": "Promo code applied successfully!",
  "proceed_to_payment": "Proceed to Payment",

  // === ARTICLES ===
  "read_more": "Read More",
  "comments": "Comments",
  "share": "Share",
  "views": "Views",
  "published_date": "Published",
  "author": "Author",
  "submit_news": "Submit News",
  "submitNews": "Submit News",
  "featured_article": "Featured article",
  "trending": "Trending",
  "latest_news": "Latest News",
  "most_read": "Most Read",
  "related_articles": "Related Articles",
  "article_title": "Article Title...",
  "excerpt_summary": "Excerpt / Summary",
  "featured_image": "Featured Image",
  "article_content": "Article content",
  "ai_image_prompt": "AI Image Prompt",
  "describe_thumbnail": "Describe the thumbnail image to generate...",
  "first_process_publish": "First process and publish the article",
  "revision_restored": "Revision restored!",
  "search_articles": "Search articles...",
  "new_article": "New Article",
  "write_new_article": "Write New Article",
  "view_all": "View all",
  "no_articles": "No articles found",
  "article_views": "Views",

  // === COMMENTS ===
  "post_comment": "Post comment",
  "failed_post_comment": "Failed to post comment.",
  "delete_failed": "Delete failed.",
  "commenting_rules": "Commenting Rules",

  // === JOBS / VIBEPOSAO ===
  "vibeposao": "Times Posao",
  "find_jobs": "Find Jobs",
  "post_job": "Post a Job",
  "wish_roles": "Wish Roles",
  "applications": "Applications",
  "employer": "Employer",
  "job_seeker": "Job Seeker",
  "company": "Company",
  "salary": "Salary",
  "location": "Location",
  "apply_now": "Apply Now",
  "saved_jobs": "Saved Jobs",
  "my_applications": "My Applications",
  "featured_jobs": "Featured Jobs",
  "job_categories": "Job Categories",
  "all_jobs": "All Jobs",
  "full_time": "Full Time",
  "part_time": "Part Time",
  "remote": "Remote",
  "job_postings": "Job Postings",
  "companies": "Companies",
  "all_types": "All Types",
  "analytics": "Analytics",
  "export_data": "Export Data",
  "feature_flags": "Feature Flags",
  "feature_job": "Feature Job",
  "promote_job": "Promote Job",
  "featured_duration": "Featured Duration",
  "salary_min": "Min Salary",
  "salary_max": "Max Salary",

  // === CLASSIFIEDS ===
  "classifieds": "Classifieds",
  "all_categories": "All Categories",
  "all_status": "All Status",
  "category_distribution": "Category Distribution",
  "electronics": "Electronics",
  "vehicles": "Vehicles",
  "real_estate": "Real Estate",
  "services": "Services",
  "other": "Other",
  "price": "Price",
  "seller": "Seller",
  "buyer": "Buyer",

  // === ADS & ADVERTISING ===
  "advertising": "Advertising",
  "ad_management": "Ad Management",
  "ad_formats": "Ad Formats",
  "campaigns": "Campaigns",
  "impressions": "Impressions",
  "clicks": "Clicks",
  "cpm": "CPM",
  "ctr": "CTR",
  "advertiser": "Advertiser",
  "book_ad": "Book Ad",
  "ad_price_list": "Ad Price List",
  "select_format": "Select Format",
  "booking_details": "Booking Details",
  "your_bookings": "Your Bookings",
  "active_ads": "Active Ads",
  "ad_format": "Ad Format",
  "dimensions": "Dimensions",
  "target_impressions": "Target Impressions",
  "ad_pricing_formats_campaigns": "Pricing, formats, campaigns and tracking",
  "advertiser_email": "Advertiser email",
  "desktop": "Desktop",
  "mobile": "Mobile",
  "tablet": "Tablet",
  "create_first_ad": "Create your first ad",
  "daily_budget": "Daily Budget",
  "duration_days": "Duration (days)",
  "advertiser_analytics": "Advertiser Analytics",
  "avg_ctr": "Avg CTR",
  "campaign_details": "Campaign Details",
  "daily_performance": "Daily Performance",
  "end_date": "End Date",
  "start_date": "Start Date",
  "enter_advertiser_email": "Enter your advertiser email...",
  "enter_email_to_view": "Enter your advertiser email above to view your campaign performance",
  "active_campaigns": "Active Campaigns",
  "manage_bookings": "Manage advertiser bookings",
  "no_bookings": "No bookings found",
  "pending_approval": "Pending Approval",
  "performance": "Performance",

  // === ADSENSE ===
  "adsense_settings": "AdSense & Ad Positions",
  "adsense_client_id": "AdSense Client ID",
  "adsense_global_toggle": "AdSense Global Toggle",
  "adsense_enable_disable": "Enable/disable all automated ad serving",
  "adsense_script_code": "AdSense Script Code",
  "ad_position_settings": "Ad Position Settings",
  "click_url": "Click URL (destination)",
  "custom_ad_code": "Custom Ad Code",
  "custom_banner_url": "Custom Banner URL",
  "configure_position": "Configure each position with a custom banner image or ad code",
  "ad_code_placeholder": "<script>...</script> or AdSense slot code",

  // === EMAIL ===
  "email_opens": "Email Opens",
  "email_clicks": "Email Clicks",
  "click_rate": "Click Rate",
  "open_rate": "Open Rate",
  "email_campaigns": "Email Campaigns",
  "email_subject": "Email Subject",
  "email_content": "Email content...",
  "unique_opens": "Unique Opens",
  "unique_clicks": "Unique Clicks",
  "no_campaigns": "No campaigns",
  "new_campaign": "New Campaign",
  "send_campaign": "Send Campaign",

  // === TRANSLATION ===
  "translate_all": "Translate All",
  "translation_status": "Translation Status",
  "missing_translations": "Missing Translations",
  "translations": "Translations",

  // === SOCIAL ===
  "social_media": "Social Media",
  "facebook": "Facebook",
  "twitter": "Twitter",
  "instagram": "Instagram",
  "linkedin": "LinkedIn",
  "youtube": "YouTube",
  "api_key": "API Key",
  "api_secret": "API Secret",
  "access_token": "Access Token",
  "access_secret": "Access Secret",
  "business_account_id": "Business Account ID",
  "client_id": "Client ID",
  "client_secret": "Client Secret",
  "auto_posting": "Auto-posting and social integrations",
  "auto_share_articles": "Automatically share published articles on connected platforms",
  "add_api_keys": "Add API keys in Configure tab",
  "social_scheduler": "Social Scheduler",
  "compose_social_post": "Compose Social Post",
  "caption": "Caption",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#news #croatia...",
  "platforms": "Platforms",
  "post_now": "Post Now",
  "no_scheduled_posts": "No scheduled posts yet",

  // === PUSH NOTIFICATIONS ===
  "push_notifications": "Push Notifications",
  "notification_title": "Notification Title",
  "notification_body": "Notification Body",
  "new_notification": "New Notification",
  "new_push_notification": "New Push Notification",
  "sent_campaigns": "Sent Campaigns",
  "no_sent_notifications": "No sent notifications",
  "category_push_subscribers": "Category Push Subscribers",
  "linked_email_campaign": "Linked to email campaign",
  "no_linked_campaign": "No linked campaign",

  // === ADMIN NAVIGATION ===
  "admin_nav_management": "Management",
  "admin_nav_dashboard": "Dashboard",
  "admin_nav_live_analytics": "Live Analytics",
  "admin_nav_ai_content": "AI Content Processing",
  "admin_nav_hero_settings": "Hero Section Settings",
  "admin_nav_breaking_news": "Breaking / Flash News",
  "admin_nav_breaking_expiry": "Breaking News Expiry",
  "admin_nav_streams": "Stream Management",
  "admin_nav_ad_management": "Ad Management",
  "admin_nav_content": "Content",
  "admin_nav_articles": "Articles",
  "admin_nav_blog": "Blog",
  "admin_nav_sponsored": "Sponsored",
  "admin_nav_feeds": "RSS Feeds",
  "admin_nav_comments": "Comments",
  "admin_nav_pages": "Pages",
  "admin_nav_imprint": "Imprint - Team",
  "admin_nav_media": "Media",
  "admin_nav_categories": "Categories",
  "admin_nav_series": "Article Series",
  "admin_nav_authors": "Authors",
  "admin_nav_quizzes": "Quizzes",
  "admin_nav_editorial": "Editorial",
  "admin_nav_editorial_workflow": "Editorial Workflow",
  "admin_nav_bulk_operations": "Bulk Operations",
  "admin_nav_scheduler": "Content Scheduler",
  "admin_nav_content_calendar": "Content Calendar",
  "admin_nav_duplicate_detection": "Duplicate Detection",
  "admin_nav_sanitization": "Content Sanitization",
  "admin_nav_users_subscriptions": "Users & Subscriptions",
  "admin_nav_users": "Users",
  "admin_nav_subscriptions": "Subscriptions",
  "admin_nav_promo_codes": "Promo Codes",
  "admin_nav_vouchers": "Vouchers / Discounts",
  "admin_nav_finance": "Finance",
  "admin_nav_payments": "Payments",
  "admin_nav_invoices": "Invoices",
  "admin_nav_pricing": "Pricing",
  "admin_nav_micropayments": "Micro-payments",
  "admin_nav_tips": "Tips / Donations",
  "admin_nav_monetization": "Monetization",
  "admin_nav_portals": "Portals",
  "admin_nav_job_ads": "Job Ads",
  "admin_nav_classifieds": "Classifieds",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_sponsored_marketplace": "Sponsor Marketplace",
  "admin_nav_analytics_ai": "Analytics & AI",
  "admin_nav_analytics": "Analytics",
  "admin_nav_advanced_analytics": "Advanced Analytics",
  "admin_nav_ab_testing": "A/B Testing",
  "admin_nav_heatmaps": "Reading Heatmap",
  "admin_nav_visitor_map": "Visitor Map",
  "admin_nav_recommendations": "Content Recommendations",
  "admin_nav_performance_forecast": "Performance Forecast",
  "admin_nav_competitor_monitoring": "Competitor Monitoring",
  "admin_nav_churn_prediction": "Churn Prediction",
  "admin_nav_seo_distribution": "SEO & Distribution",
  "admin_nav_seo_dashboard": "SEO Dashboard",
  "admin_nav_content_health": "Content Health",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_newsletter_digest": "Newsletter Digest",
  "admin_nav_syndication": "Syndication API",
  "admin_nav_marketing": "Marketing",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_email_campaigns": "Email Campaigns",
  "admin_nav_push_notifications": "Push Notifications",
  "admin_nav_social": "Social Media",
  "admin_nav_social_scheduler": "Social Scheduler",
  "admin_nav_ads": "Ad Management",
  "admin_nav_ads_report": "Ad Report",
  "admin_nav_adsense": "AdSense Settings",
  "admin_nav_system": "System",
  "admin_nav_translations": "Translations",
  "admin_nav_llm_usage": "LLM Usage",
  "admin_nav_tuzibaba": "Tužibaba Reports",
  "admin_nav_ponuda": "Ponuda Generator",
  "admin_nav_footer_partners": "Footer Partners",
  "admin_nav_surveys": "Surveys",
  "admin_nav_chat_sessions": "Chat Sessions",
  "admin_nav_docs": "Documentation",
  "admin_nav_import": "Import",
  "admin_nav_reports": "Content Reports",
  "admin_nav_audit_log": "Audit Log",
  "admin_nav_health": "System Health",
  "admin_nav_security": "Security",
  "admin_nav_settings": "Settings",
  "admin_nav_landing_pages": "Landing Pages",
  "admin_nav_branding": "Rebranding",
  "admin_nav_widgets": "Widgets / Catalogs",
  "admin_nav_county_map": "County Map",
  "admin_nav_times_brands": "Times Brands",
  "admin_nav_crypto": "Crypto Widget",
  "admin_nav_portal_toggle": "Portal Management",
  "admin_nav_doktor_earnings": "Doktor Earnings",
  "admin_nav_photo_verification": "Photo Verification",
  "admin_nav_menu_manager": "Menu Manager",
  "admin_nav_versioning": "Version History",
  "admin_nav_ugc_review": "Citizen Content",
  "admin_nav_affiliates": "Affiliate Links",
  "admin_nav_db_backup": "Database",

  // === ADMIN DASHBOARD ===
  "admin_dashboard_title": "Dashboard",
  "admin_total_articles": "Total Articles",
  "admin_total_users": "Total Users",
  "admin_total_views": "Total Views",
  "admin_published_today": "Published Today",
  "admin_comments": "Comments",
  "admin_job_postings": "Job Postings",
  "admin_classifieds": "Classifieds",
  "admin_premium_users": "Premium Users",
  "admin_recent_articles": "Recent Articles",
  "admin_quick_actions": "Quick Actions",
  "admin_write_new_article": "Write New Article",
  "admin_manage_feeds": "Manage Feeds",
  "admin_live_analytics": "Live Analytics",
  "admin_site_settings": "Site Settings",
  "admin_doktor_earnings": "Doktor Earnings",
  "admin_menu_manager": "Menu Manager",
  "admin_bug_reports": "Bug Reports",
  "admin_no_pending_reports": "No pending reports",
  "admin_system_status": "System Status",
  "admin_api_server": "API Server",
  "admin_database": "Database",
  "admin_feed_crawler": "Feed Crawler",
  "admin_view_health_report": "View full health report",

  // === ADMIN COMMON ===
  "admin_search_placeholder": "Search admin...",
  "admin_bulk_operations": "Bulk Operations",
  "admin_mass_management": "Mass article management",
  "admin_action": "Action",
  "admin_add_tag": "Add Tag",
  "admin_set_category": "Set Category",
  "admin_set_featured": "Set Featured",
  "admin_export_csv": "Export CSV",
  "admin_create_voucher": "Create Voucher",
  "admin_create_manage_promo": "Create and manage promotional codes",
  "admin_discount": "Discount",
  "admin_fixed_amount": "Fixed Amount",
  "admin_auto": "AUTO",

  // === ADMIN USERS ===
  "admin_users_title": "Users",
  "admin_admins": "Admins",
  "admin_frozen": "Frozen",
  "admin_joined": "Joined",
  "admin_plan": "Plan",
  "admin_role_change_failed": "Failed to update role.",

  // === ADMIN ARTICLES ===
  "admin_articles_title": "Articles",
  "admin_article_actions": "Actions",
  "admin_article_category": "Category",
  "admin_article_views": "Views",
  "admin_article_published": "Published",
  "admin_new_author_name": "New author name...",
  "admin_author_change_failed": "Author change failed.",
  "admin_bulk_delete_failed": "Bulk delete failed.",

  // === ADMIN AUTHORS ===
  "admin_authors_title": "Authors",
  "admin_create_author": "Create Author",
  "admin_full_name": "Full name",
  "admin_bio": "Bio",
  "admin_columnist": "Columnist",
  "admin_contributor": "Contributor",
  "admin_editor_role": "Editor",
  "admin_articles_count": "Articles",

  // === ADMIN BLOG ===
  "admin_blog_title": "Blog",
  "admin_blog_manage": "Manage blog posts with rich content editor",
  "admin_new_post": "New Post",
  "admin_choose_gallery": "Choose from Gallery",
  "admin_general": "General",

  // === ADMIN FEEDS ===
  "admin_feeds_title": "RSS Feeds",
  "admin_add_feed": "Add Feed",
  "admin_feed_name": "Feed Name",
  "admin_feed_url": "Feed URL",
  "admin_article_selector": "Article selector (CSS, e.g. article.news)",
  "admin_content_filter": "Content Filter Terms",
  "admin_crawl_now": "Crawl now",
  "admin_clear_log": "Clear Log",
  "admin_active_feeds": "Active Feeds",

  // === ADMIN ANALYTICS ===
  "admin_analytics_title": "Analytics",
  "admin_content_stats": "Content Stats",
  "admin_draft_articles": "Draft Articles",
  "admin_published_articles": "Published Articles",
  "admin_top_articles_views": "Top Articles by Views",

  // === ADMIN LIVE ANALYTICS ===
  "admin_live_analytics_title": "Live Analytics",
  "admin_active_now": "Active Now",
  "admin_browser": "Browser",
  "admin_browsers": "Browsers",
  "admin_coordinates": "Coordinates",
  "admin_countries": "Countries",
  "admin_devices": "Devices",
  "admin_device": "Device",

  // === ADMIN HEALTH ===
  "admin_health_title": "Health Check",
  "admin_core_services": "Core Services",
  "admin_api_latency": "API Latency",
  "admin_db_latency": "DB Latency",
  "admin_db_size": "DB Size",
  "admin_disk_usage": "Disk Usage",
  "admin_memory": "Memory",
  "admin_media_storage": "Media Storage",
  "admin_integrations": "Integrations",
  "admin_collection_stats": "Collection Statistics",

  // === ADMIN MONETIZATION ===
  "admin_monetization_title": "Monetization Dashboard",
  "admin_active_subscribers": "Active subscribers",
  "admin_ad_performance": "Ad Performance",
  "admin_no_published_articles": "No published articles found",

  // === ADMIN SEO ===
  "admin_seo_title": "SEO Dashboard",
  "admin_seo_desc": "Content optimization, GSC & sitemap management",
  "admin_avg_seo_score": "Avg SEO Score",
  "admin_custom_meta": "Custom Meta",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Grade",
  "admin_index_now": "IndexNow",
  "admin_last_submissions": "Last Submissions",
  "admin_settings_saved": "Settings saved",

  // === ADMIN AI CONTENT ===
  "admin_ai_content_title": "AI Content Processing",
  "admin_ai_prompt_settings": "AI Prompt & Model Settings",
  "admin_auto_save_draft": "Auto-save as draft",
  "admin_file": "File",
  "admin_edit_in_cms": "Edit in CMS",
  "admin_keywords": "Keywords",
  "admin_short_desc": "Short description",
  "admin_llm_model": "LLM Model",
  "admin_meta_description": "Meta description",

  // === ADMIN IMPORT ===
  "admin_import_title": "Croatia Times Import Platform",
  "admin_click_button": "Click the button",
  "admin_copy_text": "Copy",
  "admin_copy_ip": "Copy IP address",
  "admin_username": "Username",
  "admin_password_field": "Password",
  "admin_max_articles": "Max. articles",
  "admin_mysql_host": "MySQL Host",
  "admin_mysql_db": "MySQL database",
  "admin_db_name": "Database name",

  // === ADMIN DOCS ===
  "admin_docs_title": "Documentation",
  "admin_docs_api_ref": "API Reference",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Getting Started",
  "admin_docs_implemented": "Implemented",
  "admin_docs_no_pages": "No documentation pages yet",
  "admin_docs_order": "Order",
  "admin_docs_download_pdf": "Download PDF",

  // === ADMIN SETTINGS ===
  "admin_settings_title": "Settings",
  "admin_brand_theme": "Brand & Theme",
  "admin_accent_color": "Accent Color",
  "admin_default_language": "Default Language",

  // === ADMIN BRANDING ===
  "admin_branding_title": "Rebranding Module",
  "admin_branding_desc": "Customize site appearance (System Admin Only)",
  "admin_color_scheme": "Color Scheme",
  "admin_primary": "Primary",
  "admin_secondary": "Secondary",
  "admin_accent": "Accent",
  "admin_site_identity": "Site Identity",
  "admin_favicon": "Favicon",
  "admin_no_logo": "No logo",
  "admin_no_icon": "No icon",
  "admin_site_logo": "Site Logo",
  "admin_thumbnail_settings_saved": "Thumbnail settings saved",

  // === ADMIN SPONSORED ===
  "admin_sponsored_title": "Sponsored Articles",
  "admin_advertiser_name": "Advertiser Name",
  "admin_advertiser_email": "Advertiser Email",
  "admin_cpc": "CPC (EUR)",

  // === ADMIN LANDING PAGES ===
  "admin_landing_title": "Landing Pages",
  "admin_activate": "Activate",
  "admin_default": "DEFAULT",
  "admin_active_label": "ACTIVE",
  "admin_advertisements": "Advertisements",
  "admin_breaking_ticker": "Breaking News Ticker",
  "admin_categories_grid": "Categories Grid",
  "admin_classic_portal": "Classic News Portal",

  // === ADMIN A/B TESTING ===
  "admin_ab_testing_title": "A/B Testing",

  // === ADMIN CONTENT CALENDAR ===
  "admin_content_calendar_title": "Content Calendar",

  // === ADMIN SURVEYS ===
  "admin_surveys_title": "Surveys",

  // === MARKETING PAGE ===
  "marketing_dashboard": "Marketing Dashboard",
  "marketing_live_metrics": "Live performance metrics for Croatia Times",
  "marketing_published_articles": "Published Articles",
  "marketing_registered_users": "Registered Users",
  "marketing_total_views": "Total Page Views",
  "marketing_today_views": "Today's Views",

  // === PROFILE PAGE ===
  "profile_admin_access": "Admin Quick Access",
  "profile_dashboard": "Dashboard",
  "profile_analytics": "Analytics",
  "profile_articles": "Articles",
  "profile_edit": "Edit Profile",

  // === RECIPES PAGE ===
  "recipes_title": "Recipes",
  "recipes_add_first": "Add your first recipe",
  "recipes_filters": "Filters",
  "recipes_featured": "Featured Recipes",
  "recipes_category": "Category",
  "recipes_easy": "Easy",
  "recipes_latest": "Latest Recipes",
  "recipes_most_popular": "Most Popular Recipes",
  "recipes_browse_all": "Browse all recipes",
  "recipes_search": "Search recipes...",
  "recipes_ingredient": "Ingredient",
  "recipes_ingredients": "Ingredients",
  "recipes_instructions": "Instructions",
  "recipes_prep_time": "Prep Time",
  "recipes_cook_time": "Cook Time",
  "recipes_servings": "Servings",

  // === DOKTOR PAGE ===
  "doktor_biography": "Biography",
  "doktor_license_number": "License Number",
  "doktor_waiting_room": "Waiting Room",
  "doktor_chat": "Chat",
  "doktor_date": "Date",
  "doktor_control_date": "Control Date",
  "doktor_birth_date": "Date of Birth",
  "doktor_diagnosis": "Diagnosis",
  "doktor_add_document": "Add Document",
  "doktor_panel": "Doctor Panel",
  "doktor_patient_name": "Patient Name",
  "doktor_enter_patient_name": "Enter patient name",
  "doktor_enter_name_specialization": "Enter name and at least one specialization",
  "doktor_text_min_chars": "Text must have at least 50 characters",

  // === DATING PAGE ===
  "dating_block": "Block",
  "dating_boosts": "Boosts",
  "dating_next": "Next",
  "dating_add_video": "Add a short video so potential matches can get to know you better",
  "dating_verify_identity": "Verify that you are a real person",
  "dating_voice_message": "Voice Message",
  "dating_city": "City",
  "dating_users": "Users",
  "dating_personality_quiz": "Personality Quiz",
  "dating_quiz_completed": "Personality quiz completed",

  // === MAJSTOR PAGE ===
  "majstor_flexible": "Flexible",
  "majstor_city": "City",
  "majstor_urgent": "Urgent",
  "majstor_categories": "Categories",
  "majstor_service_categories": "Service Categories",
  "majstor_max_budget": "Max budget (EUR)",
  "majstor_min_budget": "Min budget (EUR)",
  "majstor_my_requests": "My Requests",
  "majstor_request_title": "Request Title *",
  "majstor_company_name": "Company Name *",

  // === LOYALTY PAGE ===
  "loyalty_badges": "Badges",
  "loyalty_consecutive_days": "Consecutive Days",
  "loyalty_available_rewards": "Available Rewards",
  "loyalty_available_points": "Available Points",
  "loyalty_error": "Error",
  "loyalty_used_rewards": "Used Rewards",
  "loyalty_leaderboard": "Leaderboard",
  "loyalty_leaderboard_empty": "Leaderboard is empty",
  "loyalty_rewards": "Rewards",

  // === CLASSIFIEDS PAGE ===
  "classifieds_title": "Classifieds",

  // === EVENTS ===
  "events_calendar": "Event Calendar",

  // === LIVE STREAM ===
  "live_stream": "Live Stream",

  // === SEARCH PAGE ===
  "search_results_for": "Search Results for",

  // === STATIC PAGES ===
  "about_title": "About Us",
  "contact_title": "Contact",
  "contact_us": "Contact Us",
  "privacy_title": "Privacy Policy",
  "cookies_title": "Cookie Policy",
  "imprint_title": "Imprint",
  "submit_bug_title": "Submit Bug Report",
  "submit_news_title": "Submit News",
  "reposting_rules_title": "Reposting Rules",
  "copyright_notice": "Copyright",
  "advertising_cookies": "Advertising Cookies",
  "analytics_cookies": "Analytics Cookies",
  "bug_description": "Bug Description",
  "be_respectful": "Be respectful and civil to other users and subjects of the articles",

  // === MISC PAGES ===
  "contact": "Contact",
  "about": "About",
  "privacy": "Privacy",
  "cookies": "Cookies",
  "imprint": "Imprint",
  "breaking": "BREAKING NEWS",

  // === WORKING HOURS ===
  "working_hours_saved": "Working hours saved!",

  // === ERRORS ===
  "error_generating_digest": "Error generating digest",
  "error_sending": "Error sending",
  "post_error": "Post error",
  "error_saving_settings": "Error saving",
  "error_uploading_photo": "Failed to upload photo",
  "filter_terms_saved": "Filter terms saved!",

  // === CRYPTO WIDGET ===
  "crypto_widget_title": "Crypto",
  "crypto_price": "Price",
  "crypto_change_24h": "24h Change",
  "crypto_market_cap": "Market Cap",

  // === POLL ===
  "poll_vote": "Vote",
  "poll_results": "Results",
  "poll_total_votes": "Total Votes",

  // === ACCESSIBILITY ===
  "accessibility_title": "Accessibility",
  "accessibility_font_size": "Font Size",
  "accessibility_contrast": "Contrast",
  "accessibility_animations": "Animations",

  // === CHATBOT ===
  "chatbot_title": "Chat Assistant",
  "chatbot_placeholder": "Type a message...",
  "chatbot_send": "Send",

  // === DATA VISUALIZATION ===
  "data_viz_title": "Data Visualization",

  // === ADMIN SPECIFIC ===
  "admin_sponsored_marketplace": "Sponsored Marketplace",
  "admin_high_leads": "High Value Leads",
  "admin_dynamic_pricing": "Dynamic Pricing",
  "admin_competitor_monitoring": "Competitor Monitoring",
  "admin_churn_prediction": "Churn Prediction",
  "admin_performance_forecast": "Performance Forecast",
  "admin_platform_audit": "Platform Audit",
  "admin_photo_verification": "Photo Verification",
  "admin_portal_toggle": "Portal Management",
  "admin_service_requests": "Service Requests",
  "admin_version_history": "Version History",
  "admin_db_backup": "Database Backup",
  "admin_ugc_review": "UGC Review",
  "admin_affiliate_links": "Affiliate Links",

  // === AFFILIATE PAGE ===
  "affiliate_title": "Affiliate Program",

  // === FOR YOU PAGE ===
  "for_you_title": "For You",
  "for_you_personalized": "Personalized content based on your interests",

  // === UGC PORTAL ===
  "ugc_title": "Citizen Journalism Portal",
  "ugc_submit": "Submit Content",

  // === SPONSORED MARKETPLACE ===
  "sponsored_marketplace_title": "Sponsored Marketplace",

  // === ADVERTISE PAGE ===
  "advertise_title": "Advertise with Us",
  "advertise_reach_audience": "Reach our audience",
  "advertise_contact_sales": "Contact Sales",
  "advertise_get_started": "Get Started",

  // === COMMON ADMIN PATTERNS ===
  "admin_no_data": "No data available",
  "admin_table_header_name": "Name",
  "admin_table_header_email": "Email",
  "admin_table_header_date": "Date",
  "admin_table_header_status": "Status",
  "admin_table_header_actions": "Actions",
  "admin_confirm_action": "Are you sure?",

  // === SUBSCRIPTION PAGE ===
  "subscription_title": "Subscription Plans",

  // === PAYMENT ===
  "payment_processing": "Processing payment...",
  "payment_thank_you": "Thank you for your purchase!",

  // === MISC ===
  "general": "General",
  "order": "Order",
  "content": "Content",
  "users": "Users",
  "report": "Report",
  "reports": "Reports",
  "template": "Template",
  "templates": "Templates",
  "schedule": "Schedule",
  "scheduled": "Scheduled",
  "sent": "Sent",
  "read": "Read",
  "unread": "Unread",
  "mark_as_read": "Mark as read",
  "notifications": "Notifications",
  "no_notifications": "No notifications",
  "load_more": "Load More",
  "see_all": "See All",
  "none": "None",
  "unknown": "Unknown",
  "version": "Version",
  "documentation": "Documentation",
  "help": "Help",
  "support": "Support",
  "feedback": "Feedback",
  "terms": "Terms",
  "legal": "Legal",
  "copyright": "Copyright",
  "powered_by": "Powered by",
  "welcome": "Welcome",
  "goodbye": "Goodbye",
  "hello": "Hello",
  "thank_you": "Thank you",
  "congratulations": "Congratulations",
  "warning": "Warning",
  "info": "Info",
  "note": "Note",
  "tip": "Tip",
  "required": "Required",
  "optional": "Optional",
  "recommended": "Recommended",
  "deprecated": "Deprecated",
  "experimental": "Experimental",
  "beta": "Beta",
  "alpha": "Alpha",
  "stable": "Stable",

  // === STATIC PAGES ===
  "static_about_title": "About Us - Croatia Times",
  "static_about_lead": "Croatia Times is an independent news portal bringing you the latest news, analysis, commentary and stories from Croatia and the region. We are part of the e-mina.eu media family, with the same team and same values.",
  "static_about_mission_title": "Our Mission",
  "static_about_mission": "We are dedicated to delivering accurate, timely and quality journalism that serves the public interest. Our editorial team consists of experienced journalists with deep knowledge of Croatian and regional affairs.",
  "static_about_standards_title": "Editorial Standards",
  "static_about_standards": "Croatia Times adheres to the highest journalistic standards. We fact-check our reports, clearly label commentary and analysis, and promptly and transparently correct errors.",
  "static_about_publisher_title": "Publisher",
  "static_about_publisher": "Liber Nostra d.o.o. is the publisher of Croatia Times and e-mina.eu. The company specializes in digital media and news portals focused on the Croatian market.",
  "static_about_team_title": "Team",
  "static_about_team": "Behind Croatia Times stands a team of experienced media professionals, journalists, editors and technical experts who work on platform development and content quality. Our team is the same one behind the successful portal e-mina.eu - International News Agency.",
  "static_about_contact_title": "Contact",
  "static_about_contact": "For editorial inquiries, advertising or general information, visit our",
  "static_about_contact_page": "contact page",

  "static_contact_title": "Contact Us",
  "static_contact_sent_title": "Message Sent!",
  "static_contact_sent_desc": "We'll get back to you within 24 hours.",
  "static_contact_name": "Name",
  "static_contact_name_placeholder": "Your name",
  "static_contact_email": "Email",
  "static_contact_subject": "Subject",
  "static_contact_subject_placeholder": "How can we help?",
  "static_contact_message": "Message",
  "static_contact_message_placeholder": "Your message...",
  "static_contact_sending": "Sending...",
  "static_contact_send": "Send Message",

  "static_imprint_title": "Imprint",
  "static_imprint_publisher": "Publisher",
  "static_imprint_registered": "Registered in the Republic of Croatia",
  "static_imprint_websites": "Websites",
  "static_imprint_ct_desc": "Informative and service portal Croatia Times",
  "static_imprint_emina_desc": "International News Agency",
  "static_imprint_contact": "Contact",
  "static_imprint_editorial_email": "Email (editorial):",
  "static_imprint_ads_email": "Email (advertising):",
  "static_imprint_general_email": "Email (general inquiries):",
  "static_imprint_responsible": "Responsible for Content",
  "static_imprint_responsible_text": "Editorial team of Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_ai_notice": "Some content is generated using AI technology. Report errors or inappropriate content to",
  "static_imprint_or_via": "or via our",
  "static_imprint_copyright": "Copyright",
  "static_imprint_copyright_text": "All content published on Croatia Times is protected by copyright. Liber Nostra d.o.o. retains all rights to text, images and multimedia content published on this site. Detailed information about content reposting rules is available on the",
  "static_imprint_reposting_page": "Reposting Rules page",
  "static_imprint_disclaimer": "Disclaimer",
  "static_imprint_disclaimer_text": "Despite careful content control, we assume no responsibility for external links. Their operators are solely responsible for their content.",
  "static_imprint_last_updated": "Last updated: February 2026",

  "static_privacy_title": "Privacy Policy",
  "static_privacy_lead": "Croatia Times respects your privacy and is committed to protecting your personal data.",
  "static_privacy_data_title": "Data We Collect",
  "static_privacy_data_text": "We collect data you provide directly (name, email when signing up), usage data (pages visited, articles read), and technical data (IP address, browser type).",
  "static_privacy_usage_title": "How We Use Your Data",
  "static_privacy_usage_text": "We use your data to deliver our news service, personalize your experience, send newsletters (with your consent), and improve our platform.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_cookies_text": "We use cookies for functionality and analytics. See our Cookie Policy for details.",
  "static_privacy_retention_title": "Data Retention",
  "static_privacy_retention_text": "We retain your data for as long as your account is active, or as needed for legal purposes.",
  "static_privacy_rights_title": "Your Rights",
  "static_privacy_rights_text": "You have the right to access, correct, or delete your personal data. Contact us at",
  "static_privacy_controller": "Data Controller: Liber Nostra d.o.o.",
  "static_privacy_last_updated": "Last updated: January 2026",

  "static_cookies_title": "Cookie Policy",
  "static_cookies_what_title": "What Are Cookies",
  "static_cookies_what_text": "Cookies are small text files placed on your device when you visit a website. They help the site remember your preferences and understand how you use it.",
  "static_cookies_types_title": "Types of Cookies We Use",
  "static_cookies_necessary_title": "Necessary Cookies",
  "static_cookies_necessary_text": "These are required for the site to function (login sessions, theme preferences). They cannot be disabled.",
  "static_cookies_analytics_title": "Analytics Cookies",
  "static_cookies_analytics_text": "Google Analytics helps us understand how visitors use our site. Data is anonymised where possible.",
  "static_cookies_advertising_title": "Advertising Cookies",
  "static_cookies_advertising_text": "We may use Google AdSense cookies to serve relevant advertisements.",
  "static_cookies_managing_title": "Managing Cookies",
  "static_cookies_managing_text": "You can control cookies through your browser settings. Disabling necessary cookies may affect site functionality.",

  "static_commenting_title": "Commenting Rules",
  "static_commenting_intro": "We welcome constructive discussion. To keep our comment section positive and productive, please follow these rules:",
  "static_commenting_rule_1": "Be respectful and civil to other users and subjects of the articles",
  "static_commenting_rule_2": "No hate speech, racism, sexism, or discrimination of any kind",
  "static_commenting_rule_3": "No spam, advertising, or promotional content",
  "static_commenting_rule_4": "No misinformation or spreading of unverified claims",
  "static_commenting_rule_5": "No personal attacks or harassment",
  "static_commenting_rule_6": "Stay on topic and contribute to the conversation",
  "static_commenting_rule_7": "No personal or confidential information about third parties",
  "static_commenting_violation": "Comments that violate these rules may be removed without notice. Repeat offenders may be permanently banned.",
  "static_commenting_login": "To comment, you must be registered and logged in to Croatia Times.",

  "static_reposting_title": "Reposting Rules",
  "static_reposting_copyright_title": "Copyright",
  "static_reposting_copyright_text": "All content published on Croatia Times is protected by copyright. Liber Nostra d.o.o. retains all rights to the text, images, and multimedia published on this website.",
  "static_reposting_permitted_title": "Permitted Use",
  "static_reposting_permitted_text": "You may share links to our articles on social media and other platforms. Short quotes (up to 2 paragraphs) may be used with clear attribution and a link back to the original article.",
  "static_reposting_prohibited_title": "Prohibited Use",
  "static_reposting_prohibited_text": "Full reprinting of articles without written permission is prohibited. Images may not be reproduced without permission. Automated scraping of content is strictly forbidden.",
  "static_reposting_permission_title": "Permission Requests",
  "static_reposting_permission_text": "For permission to reprint content, contact us at",

  "static_submit_news_title": "Submit Your News",
  "static_submit_news_intro": "Have news? Send it here and our editorial team will review it.",
  "static_submit_news_limit": "We accept photos and videos up to",
  "static_submit_news_thanks": "Thank you for your submission! Our team will review it shortly.",
  "static_submit_news_your_name": "Your Name",
  "static_submit_news_headline": "News Headline",
  "static_submit_news_details": "Story Details",
  "static_submit_news_details_placeholder": "Describe the news...",
  "static_submit_news_source": "Source / Reference (optional)",
  "static_submit_news_source_placeholder": "URL or reference",
  "static_submit_news_photos": "Photos / Video (up to",
  "static_submit_news_file_limit_error": "File exceeds the limit of",
  "static_submit_news_sending": "Sending...",
  "static_submit_news_send": "Submit News",
  "static_submit_news_choose_file": "Choose file",
  "static_submit_news_no_file": "No file chosen",

  "static_bug_title": "Report a Bug",
  "static_bug_intro": "Found something that doesn't work correctly? Let us know and we'll fix it promptly.",
  "static_bug_thanks": "Thank you for your report! We'll investigate and fix the issue.",
  "static_bug_page_url": "Page URL (where the bug occurred)",
  "static_bug_description": "Bug Description",
  "static_bug_description_placeholder": "Describe what happened and how to reproduce the issue...",
  "static_bug_screenshot": "Screenshot (optional)",
  "static_bug_submitting": "Submitting...",
  "static_bug_submit": "Submit Bug Report",

  // === HEADER SPECIFIC ===
  "header_portals_label": "Portals",
  "header_weather_humidity": "Humidity",
  "header_weather_wind": "Wind",

  // === HOME PAGE SPECIFIC ===
  "home_podcast_title": "Weekly Tech Roundup: AI in Croatian Startups",
  "home_video_title": "Inside Zagreb: Street Art Documentary",

  // === TIMES BRANDS & COUNTY MAP ===
  "times_brands_subtitle": "Explore all Times services",
  "county_map_subtitle": "Select a county to see local news",
  "no_county_articles": "No articles found for the selected county."
}
